import { render, staticRenderFns } from "./Conoce_Comp.vue?vue&type=template&id=de6f92ca&scoped=true&"
import script from "./Conoce_Comp.vue?vue&type=script&lang=js&"
export * from "./Conoce_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Conoce_Comp.vue?vue&type=style&index=0&id=de6f92ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6f92ca",
  null
  
)

export default component.exports